<template>
  <input
    :id="this.id"
    ref="inputRef"
    type="text"
    :value="modelValue"
    @input="this.updateSize($event)"
    @focus="onFocus($event.target.id)"
    @blur="onBlur($event.target.id)"
    class="form-control autosized-input text-hover input-focus"
    :placeholder="placeholder"
    :maxlength="maxlength"
  />
</template>

<script>
export default {
  name: "FocusTextInputGroup",
  emits: ["update:modelValue"],
  props: {
    id: String,
    modelValue: String,
    placeholder: { type: String, required: false },
    maxlength: { type: Number, required: false },
    upper: { type: Boolean, required: false, default: false },
  },
  methods: {
    updateSize(event) {
      const span = document.getElementById(`Size${this.id}`);
      const input = document.getElementById(this.id);
      span.innerText = input.value;
      if (event !== undefined) {
        if (this.upper === true) {
          this.$emit("update:modelValue", event.target.value.toUpperCase());
        } else {
          this.$emit("update:modelValue", event.target.value);
        }
      }
    },
    onFocus(id) {
      document.getElementById(id).removeAttribute("readonly");
      document.getElementById(id).select();
    },
    onBlur(id) {
      document.getElementById(id).setAttribute("readonly", true);
    },
  },
  mounted() {
    this.updateSize();
  },
};
</script>

<style>
.relative-parent {
  position: relative;
  min-width: 1em;
  width: min-content;
  height: 43px;
}

.size-calibration {
  visibility: hidden;
  white-space: pre;
  position: relative;
}

.autosized-input {
  position: absolute;
  left: 0;
  width: 100%;
}

.size-calibration,
.autosized-input {
  font-family: Poppins, Helvetica, "sans-serif";
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
}

.text-hover:hover {
  color: black;
}
</style>
